import { SessionGroup, SplitType } from '../../invitations/models/invitation.model';

/** Human labels for `SplitType`, shared by the sessions list and the board header badge. */
export const SPLIT_TYPE_LABELS: Record<SplitType, string> = {
  similar: 'Similar Preference',
  diverse_exact: 'Diverse Preference: Exact',
};

/** A participant source in the wizard picker: a whole org, or a single invitation. */
export interface SessionSource { kind: 'org' | 'invitation'; id: string; }

/**
 * A standalone session: participants pooled across invitations/orgs, "based on" one primary
 * invitation, split into groups. `participantIds` and group `memberIds` REFERENCE participants in
 * the invitations store — never copied — so a name/score edit shows through with no sync step.
 */
export interface Session {
  id: string;                     // 'ses-1'
  name: string;
  primaryInvitationId: string;    // the "Based on"
  primaryInvitationName: string;  // denormalised for the table
  sources: SessionSource[];       // picker chips, remembered so Edit rehydrates them
  participantIds: string[];       // ordered; spans invitations
  splitType: SplitType;
  groups: SessionGroup[];
  expiresAt?: string;             // ISO; ABSENT (undefined) means the group never expires
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

/** Payload from the wizard. The service fills in id, primaryInvitationName, createdBy, stamps, groups. */
export interface SessionDraft {
  name: string;
  primaryInvitationId: string;
  sources: SessionSource[];
  participantIds: string[];
  splitType: SplitType;
  groupCount: number;             // ignored for 'similar'
  expiresAt?: string;             // optional; absent (undefined) means the group never expires
}
